export const PAGE_SIZE = 10;
export const MOBILE_SIZE = 687;

export function isMobileView(): boolean {
  const deviceSize = window.screen.width;
  return Boolean(deviceSize <= MOBILE_SIZE);
}
